import AddMeal from '../../components/Meal/Add/AddMeal';
import { useContext } from 'react';
import MealsContext from '../../context/meals-context';

const NewMeal = () => {
  const mealsContext = useContext(MealsContext);

  const newRecipe = () => {
    mealsContext.refresh();
  };

  return <AddMeal onMealSave={newRecipe} />;
};

export default NewMeal;
